import axios, { AxiosRequestConfig, AxiosResponse, CancelTokenSource } from 'axios'
import type { ApiErrorCallback, ApiSuccessCallback } from '../types/api/BaseTypes'
import type { Lookup } from '../types/api/Lookup'

export function makeRequest<T, D = unknown> (
  options: AxiosRequestConfig, 
  success: ApiSuccessCallback<T>, 
  error: ApiErrorCallback<T>
) {
  if (options) {
    return axios<T, AxiosResponse<T>, D>({
      ...options,
      baseURL: process.env.REACT_APP_API_URL,
    })
      .then(response => {
      //response from aunt bertha which returns no results just throws a 204. Catch here to terminate.
        if (response.status === 204){
          throw new Error('There were no results for the given parameters.')
        } else if (response.status === 503) {
          throw new Error('Requests have temporarily exceeded their limits. Please try again at at later time.')
        } else {
          success(response)
        }
      })
      .catch(error)
  }
}

export function getCancelToken () {
  return axios.CancelToken.source()
}

export const getLookup = (endpoint: string, success: ApiSuccessCallback<Lookup[]>, error: ApiErrorCallback<Lookup[]>, cancelSource: CancelTokenSource) => {
  if (!endpoint) {
    console.error('No endpoint provided')
    return
  }
  const url = `Lookup/${endpoint}`
  const options = {
    method     : 'GET',
    url, 
    cancelToken: cancelSource.token,
  }
  makeRequest<Lookup[]>(options, success, error)
}

export const isCancel = (token : any) => axios.isCancel(token)

export const getAbortController = () => new AbortController()